<ion-header class="header" mode="md">
  <ion-grid fixed class="ion-no-padding">
  <ion-toolbar mode="md">
    <ion-title class="ion-text-center header-title">{{ 'PREVIEW.TITLE' | translate }}</ion-title>


    <ion-buttons slot="start" class="header-buttons" style="margin-left:-6px">
      <ion-button (click)="navigateToSlotPick()" class="header-buttons__btn">
        <ion-icon name="arrow-back-sharp" slot="icon-only" shape="round" ></ion-icon>
      </ion-button>
    </ion-buttons>

    <!--
    <ion-buttons slot="start" class="header-buttons">
      <ion-back-button color="secondary" defaultHref="" text=""></ion-back-button>
    </ion-buttons>-->
    
    <app-top-right slot="end"></app-top-right>
  </ion-toolbar>
</ion-grid>
</ion-header>


<ion-progress-bar *ngIf="'restavracija-strelec' === real?.slug || 'jaz-by-me' === real?.slug" style="height: 2px; margin-bottom: 20px;" color="secondary" value=".90" buffer="1"></ion-progress-bar>

<ion-content>
<ion-grid fixed class="ion-no-padding">
  <!--app-stepper [currentStep]="3"></app-stepper-->

  <ion-grid class="ion-no-padding stepper" *ngIf="'restavracija-strelec' !== real?.slug && 'jaz-by-me' !== real?.slug">
    <ion-row  class="ion-no-padding">
      <ion-col class="ion-no-padding" size="4">
        <ion-button (click)="navigateToServicePick()" color="light" mode="ios" class="btn--small stepper__btn ion-no-padding ion-no-margin" expand="full"
        disabled="false">
          <div>{{ 'STEPPER.HOME' | translate }}</div>
        </ion-button>
      </ion-col>

      <ion-col class="ion-no-padding" size="4">
        <ion-button (click)="navigateToSlotPick()" color="light" mode="ios" class="btn--small stepper__btn ion-no-padding ion-no-margin" expand="full"
        disabled="false">
          <div>{{ 'STEPPER.PICK_SLOT' | translate }}</div>
        </ion-button>
      </ion-col>

      <ion-col class="ion-no-padding" size="4">
        <ion-button color="secondary" mode="ios" class="btn--small stepper__btn--active ion-no-padding ion-no-margin"
        expand="full" disabled="false">
          <div>{{ 'STEPPER.PREVIEW' | translate }}</div>
        </ion-button>
      </ion-col>
    </ion-row>
  </ion-grid>


<!--div class="warning-bubble" *ngIf="pick?.partySize && real.confirmationNeededPartySize && pick?.partySize >= real.confirmationNeededPartySize">
  <p>{{ 'PREVIEW.LARGE_GROUP_BOOKING_REQUEST_WARNING' | translate }}</p>
</div-->

<app-summary [real]="real" [pick]="pick" [hidePartySize]="hidePartySize"></app-summary>

<ng-container *ngIf="services$ | async as services">
<!--ion-item *ngIf="menuPick && services.length > 1"><ion-label style="font-size:small;">{{ 'PREVIEW.PICK_MENUS' | translate }}</ion-label></ion-item-->

<ion-list *ngIf="menuPick" lines="none" detail="false" class="ion-no-padding services-list services-list--white" mode="ios">
  <ng-container *ngFor="let category of services; let i = index;"> 
  
    <ng-container *ngIf="category.id == this.pick.combination.eventPreference">
    <ion-item style="padding-bottom:10px;" (click)="category.menuOpen=!category.menuOpen" tappable class="services__item" [color]="pick?.menuStrelec?'secondary':'primary'"[color]="'secondary'" >

      <ion-label>{{ category.name| ppTranslate:category.nameTranslations:translateService.currentLang }}</ion-label>

    </ion-item>

    <ng-container *ngIf="true || category.menuOpen">
      <ng-container *ngFor="let service of category?.children; let j = index;">
        <ion-item  *ngIf="service.visibleForCustomers && ( !pick?.menuStrelec || ( pick?.menuStrelec ==  (j+1) ) )"> <!-- class="clickable" (click)="toggleService( service, category )"-->
            <ion-grid  class="ion-no-padding">
              <ion-row class="ion-no-padding ion-align-items-start services-list-row">
                <ion-col size="1">
                  &bull;
                  <!--ion-checkbox name="cb-2" mode="md" [checked]="isServicePicked(service)"></ion-checkbox-->
                </ion-col>
                <ion-col size="7" class="services-list-row__item-name">{{ service.name | ppTranslate:service.nameTranslations:translateService.currentLang }}<div class="services-list-row__item-time" style="padding-top:10px; padding-bottom:10px;"><span *ngIf="service.minimalPrice.varyPrices">{{ 'EVENT_CARD.FROM' | translate }} </span><span *ngIf="service.minimalPrice.lowestPrice">{{ service.minimalPrice.lowestPrice | currency: 'EUR' }}</span><span *ngIf="!service.minimalPrice.lowestPrice">-</span></div></ion-col>
                <ion-col size="4" class="services-list-row__item-price">
                  
                  <div class="ion-float-right" > 
                    <span>
                      <!--span *ngIf="pick?.partySize === pick?.getProductQtyById( service.id ) && menuPick && services.length == 1">{{ pick?.getProductQtyById( service.id )}} x</span-->
                      <ion-select  #mySelect class="ion-flat-right" #selectEl (ionChange)="toggleProduct( service, category, selectEl.value )" slot="end" style="min-width: 100px; margin-left: 10px; padding-right: 15px; color: white; font-weight: bold;" [ngModel]="pick.getProductQtyById( service.id )" [style.background-color]="pick?.menuStrelec?'#383e56':'#0100ee'" *ngIf="pick?.partySize && menuPick && services.length > 0" interface="popover" #qty placeholder="0">
                      <ion-select-option  [value]="0">0 x</ion-select-option>
                      <ion-select-option  *ngIf="pick?.partySize >= 1" [value]="1">1 x</ion-select-option>
                      <ion-select-option *ngIf="pick?.partySize >= 2" [value]="2">2 x</ion-select-option>
                      <ion-select-option *ngIf="pick?.partySize >= 3" [value]="3">3 x</ion-select-option>
                      <ion-select-option *ngIf="pick?.partySize >= 4" [value]="4">4 x</ion-select-option>
                      <ion-select-option *ngIf="pick?.partySize >= 5" [value]="5">5 x</ion-select-option>
                      <ion-select-option *ngIf="pick?.partySize >= 6" [value]="6">6 x</ion-select-option>
                      <ion-select-option *ngIf="pick?.partySize >= 7" [value]="7">7 x</ion-select-option>
                      <ion-select-option *ngIf="pick?.partySize >= 8" [value]="8">8 x</ion-select-option>
                      <ion-select-option *ngIf="pick?.partySize >= 9" [value]="9">9 x</ion-select-option>
                      <ion-select-option *ngIf="pick?.partySize >= 10" [value]="10">10 x</ion-select-option>
                      <ion-select-option *ngIf="pick?.partySize >= 11" [value]="11">11 x</ion-select-option>
                      <ion-select-option *ngIf="pick?.partySize >= 12" [value]="12">12 x</ion-select-option>
                      <ion-select-option *ngIf="pick?.partySize >= 13" [value]="13">13 x</ion-select-option>
                      <ion-select-option *ngIf="pick?.partySize >= 14" [value]="14">14 x</ion-select-option>
                      <ion-select-option *ngIf="pick?.partySize >= 15" [value]="15">15 x</ion-select-option>
                      <ion-select-option *ngIf="pick?.partySize >= 16" [value]="16">16 x</ion-select-option>
                      <ion-select-option *ngIf="pick?.partySize >= 17" [value]="17">17 x</ion-select-option>
                      <ion-select-option *ngIf="pick?.partySize >= 18" [value]="18">18 x</ion-select-option>
                      <ion-select-option *ngIf="pick?.partySize >= 19" [value]="19">19 x</ion-select-option>
                      <ion-select-option *ngIf="pick?.partySize >= 20" [value]="20">20 x</ion-select-option>
                      <ion-select-option *ngIf="pick?.partySize >= 21" [value]="21">21 x</ion-select-option>
                      <ion-select-option *ngIf="pick?.partySize >= 22" [value]="22">22 x</ion-select-option>
                      <ion-select-option *ngIf="pick?.partySize >= 23" [value]="23">23 x</ion-select-option>
                      <ion-select-option *ngIf="pick?.partySize >= 24" [value]="24">24 x</ion-select-option>
                      <ion-select-option *ngIf="pick?.partySize >= 25" [value]="25">25 x</ion-select-option>
                      </ion-select>
                      <!--ion-item *ngIf="menuPick && services.length > 1"><ion-label style="font-size:small;">{{ 'PREVIEW.PICK_MENUS' | translate }}</ion-label></ion-item-->
                    </span>
                  </div> 
                  <!--span class="services-list-row__item-discount"></span>
                  <span *ngIf="service.minimalPrice.varyPrices">od </span><span>{{ service.minimalPrice.lowestPrice | currency: 'EUR' }}</span-->
                
                  
                </ion-col>


                <!--ion-col size="1"></ion-col>
                <ion-col size="8" class="services-list-row__item-time">
                21,00 €
                </ion-col>
                <ion-col *ngIf="false" size="3" class="ion-text-right services-list-row__list-icon">
                  <ion-icon name="list" mode="ios"></ion-icon>
                </ion-col-->
              </ion-row>
              <!-- && isServicePicked(service) -->
              <ion-row *ngIf="service.longDescription" class="services-list-row__item-expanded-info ion-align-items-start">
                <ion-col size="1"></ion-col>
                <ion-col size="2" *ngIf="service.avatar?.document?.fileName">
                  <img class="ion-float-left" style="width: 100%; padding: 0px 16px 0px 0px"  [src]="service.avatar?.document?.fileName | ppImage" />
                </ion-col>
                <ion-col size="9">
                   <p class="formatted" innerHtml="{{ service.longDescription | ppTranslate:service.longDescriptionTranslations:translateService.currentLang }}"></p>
                </ion-col>
              </ion-row>
            </ion-grid>
          </ion-item>
      </ng-container>
    </ng-container>

  </ng-container>

  </ng-container> 

  </ion-list>
  </ng-container>

<ng-container *ngIf="me$ | async as me">
<ng-container *ngIf="me && me.getProviderUserForProviderId(real?.provider?.id)?.onBehalfOfBooker">
  <h2 class="ion-padding">Rezervacija v imenu gosta?</h2>

  <ion-item mode="md" style="">
    <ion-label style="font-weight:600; color:black;" position="stacked" mode="md"><ion-icon name="person-outline"></ion-icon> {{ 'PREVIEW.ENTER_ON_BEHALF_OF_NAME' | translate }}:</ion-label>
    <ion-input type="text" placeholder="{{ 'PREVIEW.ENTER_ON_BEHALF_OF_NAME_PLACEHOLDER' | translate }}" (input)="pick.onBehalfOfName = $event.target.value" #onBehalfOfName clearOnEdit="true"></ion-input>
  </ion-item>

  <ion-item mode="md" style="">
    <ion-label style="font-weight:600; color:black;" position="stacked" mode="md"><ion-icon name="mail-outline"></ion-icon> {{ 'PREVIEW.ENTER_ON_BEHALF_OF_EMAIL' | translate }}:</ion-label>
    <ion-input type="email" placeholder="{{ 'PREVIEW.ENTER_ON_BEHALF_OF_EMAIL_PLACEHOLDER' | translate }}" (input)="pick.onBehalfOfEmail = $event.target.value" #onBehalfOfEmail clearOnEdit="true"></ion-input>
  </ion-item>

  <ion-item class="phone-input" mode="md" >
    <ion-label mode="md" class="phone-modal__form-label" position="stacked" position="stacked"><ion-icon name="call-outline"></ion-icon> {{ 'PREVIEW.ENTER_ON_BEHALF_OF_PHONE' | translate }}</ion-label>
    <ion-intl-tel-input
        id="onBehalfOfPhone" 
        name="onBehalfOfPhone"
        defaultCountryiso="si"
        inputPlaceholder="{{ 'PREVIEW.ENTER_ON_BEHALF_OF_PHONE_PLACEHOLDER' | translate }}"
        [(ngModel)]="phone2"
        [preferredCountries]="['si', 'at', 'de',  'hr', 'it', 'se', 'ch', 'gb', 'us', 'ua', 'fr']"
        #phoneNumberControl="ngModel" 
        >
    </ion-intl-tel-input>
  </ion-item>

  <ion-item class="" style="margin-bottom: 60px;" *ngIf="pick">
      <ion-label><ion-icon name="notifications-outline"></ion-icon> Obveščaj gosta o rezervaciji</ion-label>
      <ion-toggle color="primary" [(ngModel)]="pick.onBehalfOfNotifications" name="onBehalfOfNotificationsToggle" disabled="false"></ion-toggle>
  </ion-item>

</ng-container>

<ng-container *ngIf="me?.email === 'brez.prijave@table42.app'">
  
  <h2 class="ion-padding">Vaši osebni podatki:</h2>

  <ion-item mode="md" style="">
    <ion-label style="font-weight:600; color:black;" position="stacked" mode="md"><ion-icon name="person-outline"></ion-icon> {{ 'PREVIEW.ENTER_NO_LOGIN_NAME' | translate }}*:</ion-label>
    <ion-input type="text" placeholder="{{ 'PREVIEW.ENTER_NO_LOGIN_NAME_PLACEHOLDER' | translate }}" (input)="pick.onBehalfOfName = $event.target.value" #onBehalfOfName clearOnEdit="true" required></ion-input>
  </ion-item>
  <p *ngIf="(!pick?.onBehalfOfName) && showErrors" class="error">{{ 'PREVIEW.NAME_IS_REQUIRED' | translate }}</p>


  <!--ion-item mode="md" style="">
    <ion-label style="font-weight:600; color:black;" position="stacked" mode="md"><ion-icon name="mail-outline"></ion-icon> {{ 'PREVIEW.ENTER_NO_LOGIN_EMAIL' | translate }}*:</ion-label>
    <ion-input type="email" placeholder="{{ 'PREVIEW.ENTER_NO_LOGIN_EMAIL_PLACEHOLDER' | translate }}" (input)="pick.onBehalfOfEmail = $event.target.value"  #onBehalfOfEmail clearOnEdit="true" required pattern="^[^\s@]+@[^\s@]+\.[^\s@]+$"></ion-input>
  </ion-item>
   <p *ngIf="(!pick?.onBehalfOfEmail) && showErrors" class="error">{{ 'PREVIEW.EMAIL_IS_REQUIRED' | translate }}</p>

  <p *ngIf="onBehalfOfEmail.invalid && (onBehalfOfEmail.dirty || onBehalfOfEmail.touched)" class="error">
    {{ 'PREVIEW.ENTER_VALID_EMAIL' | translate }}
  </p-->

  <ion-item mode="md" style="" *ngIf="pick">
  <ion-label style="font-weight:600; color:black;" position="stacked" mode="md">
    <ion-icon name="mail-outline"></ion-icon> 
    {{ 'PREVIEW.ENTER_NO_LOGIN_EMAIL' | translate }}*:
  </ion-label>
  <ion-input 
    type="email" 
    placeholder="{{ 'PREVIEW.ENTER_NO_LOGIN_EMAIL_PLACEHOLDER' | translate }}" 
    [(ngModel)]="pick.onBehalfOfEmail" 
    #onBehalfOfEmail="ngModel" 
    clearOnEdit="true" 
    required 
    pattern="^[^\s@]+@[^\s@]+\.[^\s@]+$">
  </ion-input>
</ion-item>

<!-- Error Message for Required Field -->
<p *ngIf="(!pick?.onBehalfOfEmail) && showErrors" class="error">
  {{ 'PREVIEW.EMAIL_IS_REQUIRED' | translate }}
</p>


  <ion-item class="phone-input" mode="md" >
    <ion-label mode="md" class="phone-modal__form-label" position="stacked" position="stacked"><ion-icon name="call-outline"></ion-icon> {{ 'PREVIEW.ENTER_NO_LOGIN_PHONE' | translate }}*</ion-label>
    <ion-intl-tel-input
        id="onBehalfOfPhone" 
        name="onBehalfOfPhone"
        defaultCountryiso="si"
        inputPlaceholder="{{ 'PREVIEW.ENTER_NO_LOGIN_PHONE_PLACEHOLDER' | translate }}"
        [(ngModel)]="phone2"
        [preferredCountries]="['si', 'at', 'de',  'hr', 'it', 'se', 'ch', 'gb', 'us', 'ua', 'fr']"
        #phoneNumberControl="ngModel" 
        >
    </ion-intl-tel-input>
  </ion-item>

  <p *ngIf="!phone2 && showErrors" class="error">{{ 'PREVIEW.PHONE_IS_REQUIRED' | translate }}</p>




  <!--ion-item class="" style="margin-bottom: 60px;" *ngIf="pick">
      <ion-label><ion-icon name="notifications-outline"></ion-icon> Obveščaj gosta o rezervaciji</ion-label>
      <ion-toggle color="primary" [(ngModel)]="pick.onBehalfOfNotifications" name="onBehalfOfNotificationsToggle" disabled="false"></ion-toggle>
  </ion-item-->

</ng-container>

</ng-container>

  <ion-item mode="md" style="margin-bottom: 200px;">
    <ion-label style="font-weight:600; color:black;" position="stacked" mode="md"><ion-icon name="pencil-outline"></ion-icon> {{ 'PREVIEW.ENTER_NOTES' | translate }}:</ion-label>
    <ion-textarea placeholder="{{ 'PREVIEW.ENTER_RESTRICTIONS' | translate }}" rows="1" (input)="pick.customerNotes = $event.target.value" #message placeholder="" auto-grow="true" clearOnEdit="true"></ion-textarea>
  </ion-item>


  <!--<ion-list>
    <ion-radio-group>
      <ion-list-header>
        Način plačila
      </ion-list-header>

      <ion-item>
        <ion-label>Plačilo v restavraciji</ion-label>
        <ion-radio value="cash"></ion-radio>
      </ion-item>

      <ion-item>
        <ion-label>Plačilo z valu</ion-label>
        <ion-radio value="valu"></ion-radio>
      </ion-item>

      <ion-item>
        <ion-label>Plačilo s kreditno kartico</ion-label>
        <ion-radio value="card"></ion-radio>
      </ion-item>

    </ion-radio-group>
  </ion-list>-->
</ion-grid>
</ion-content>

 <ion-footer mode="md" *ngIf="nextStepActive">
  <ion-toolbar  class="ion-no-padding">

    <ion-button [color]="pick?.menuStrelec?'secondary':'primary'" *ngIf="loading"  expand="full" class="btn--large ion-no-margin"><ion-spinner name="crescent"></ion-spinner></ion-button>
    

    <ion-button [color]="pick?.menuStrelec?'secondary':'primary'"  *ngIf="!loading && !paymentRequired && !minSpendRequired" [disabled]="!nextStepActive"  (click)="bookClickSubject.next( $event )" expand="full" class="btn--large ion-no-margin bottom-btn">{{ (real.confirmationNeededPartySize && pick?.partySize >= real.confirmationNeededPartySize) ? ('PREVIEW.BTN_BOOKING_REQUEST' | translate) : ('PREVIEW.BTN_BOOK' | translate) }}</ion-button>


    <ion-button [color]="pick?.menuStrelec?'secondary':'primary'"  *ngIf="!loading && ( paymentRequired || minSpendRequired )" [disabled]="!nextStepActive"  (click)="bookClickSubject.next( $event )" expand="full" class="btn--large ion-no-margin bottom-btn">{{ minSpendRequired ? ('PREVIEW.BTN_PARTIALLY_PAY' | translate) :('PREVIEW.BTN_PAY' | translate) }} {{ minSpendRequired ? (minSpendAmount | currency: '€'): (paymentAmount | currency: '€')}}</ion-button>

  </ion-toolbar>
</ion-footer>